exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-monitor[data-v-162ac2de]{min-height:300px}th[data-v-162ac2de]{color:#fff}td[data-v-162ac2de]{color:#000}td[data-v-162ac2de],th[data-v-162ac2de]{border:1px solid #fff;padding:10px;font-size:14px}tbody[data-v-162ac2de]{border-top:5px solid #fff}.table-monitor-controls[data-v-162ac2de]{margin-top:10px}", ""]);

// exports
